<button mat-icon-button class="closebtn" (click)="onClose()">
  <mat-icon>arrow_back</mat-icon>
</button>

<div #imgHost class="image-host" [class.center]="isOverview">

  <img #img [src]="imageSrc" (click)="onImageClick($event)" />

</div>